import { useState } from 'react';

/**
 * Custom hook for JSON viewer functionality
 * Returns the state and handlers needed to control a JSON viewer
 */
export const useJsonViewer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [viewerData, setViewerData] = useState(null);
  const [viewerTitle, setViewerTitle] = useState('');
  const [viewerFieldId, setViewerFieldId] = useState(null);
  const [viewerOnSave, setViewerOnSave] = useState(null);
  const [viewerCaseid, setViewerCaseid] = useState(null);
  const [viewerTag, setViewerTag] = useState(null); // Add tag state
  const [viewerStartInEditMode, setViewerStartInEditMode] = useState(false);

  const openJsonViewer = ({ title, data, fieldId = null, onSave = null, caseid = null, tag = null, startInEditMode = false }) => {
    setViewerTitle(title);
    setViewerData(data);
    setViewerFieldId(fieldId);
    setViewerOnSave(() => onSave); // Wrap in function to store the function
    setViewerCaseid(caseid);
    setViewerTag(tag); // Store tag information
    setViewerStartInEditMode(Boolean(startInEditMode && onSave));
    setIsOpen(true);
  };

  const closeJsonViewer = () => {
    setIsOpen(false);
    // Clear data after close animation
    setTimeout(() => {
      setViewerData(null);
      setViewerTitle('');
      setViewerFieldId(null);
      setViewerOnSave(null);
      setViewerCaseid(null);
      setViewerTag(null); // Clear tag
      setViewerStartInEditMode(false);
    }, 300);
  };

  const handleSaveJson = async (editedJsonData) => {
    if (viewerOnSave) {
      await viewerOnSave(editedJsonData);
    }
    closeJsonViewer();
  };

  return {
    // State
    isOpen,
    viewerData,
    viewerTitle,
    viewerFieldId,
    viewerCaseid,
    viewerTag, // Export tag state
    viewerStartInEditMode,
    
    // Actions
    openJsonViewer,
    closeJsonViewer,
    handleSaveJson
  };
};
